export default "__VITE_ASSET__DzwWlGsi__"